export function getInitials(name?: string): string {
  const trimmed = name?.trim();

  if (!trimmed) {
    return '';
  }

  const [firstName, lastName] = trimmed.split(' ');

  if (firstName && lastName) {
    return firstName.charAt(0) + lastName.charAt(0);
  }

  if (firstName) {
    return firstName.charAt(0);
  }

  return '';
}
